// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__jiOm7","log":"ModalInventoryLogs_log__2v6e2","date":"ModalInventoryLogs_date__1YgRK","userName":"ModalInventoryLogs_userName__Va_Ht"};